// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tf","itemWrapper":"th rK","itemStyle":"ti rL"};